// Related Content segments 需注意的指标顺序
export const SegmentSortMap: { [key: string]: number } = {
  Remaster: 1,
  Remasters: 2,
  DLCs: 3,
  Expansion: 4,
  Expansions: 5,
  Edition: 6, // 数据同学统计无此指标
  Bundle: 7,
  Port: 8,
  Ports: 9,
  Season: 10,
  Seasons: 11, // 数据同学统计无此指标
  'Bundled In': 12,
  'Bundled in': 13,
};

export const DownloadContentLocaleMap: { [key: string]: string } = {
  Updates: '更新',
  Fork: '',
  Standalone_Expansion: '单机版扩展',
  Port: '游戏接口',
  Bundle: '捆绑包',
  Remakes: '重制版',
  Expansions: '扩展',
  'Expanded Games': '扩展游戏',
  Season: '季票',
  Remake: '重制版',
  Episode: '章节',
  Ports: '游戏接口',
  Dlc_Addon: 'DLC插件',
  'Bundled Games': '捆绑游戏',
  'Packs / Addons': '捆绑包插件',
  Update: '更新',
  Remaster: '重制版',
  'Bundled In': '捆绑包',
  'Bundled in': '捆绑包',
  Pack: '捆绑包',
  Expansion: '扩展',
  DLCs: '可下载内容',
  Remasters: '重制版',
  Mod: '模组',
  Expanded_Game: '扩展游戏',
};

// 描述信息空态文案
export const noDataTipLocaleMap: { [key: string]: string } = {
  origin: "There's no description of the game in the database.",
  zh: '数据库中没有这个游戏的描述。',
  en: "There's no description of the game in the database.",
};
